import { useEffect } from "react"
import { Link } from "react-router-dom"
import { loadScript } from "../utils/loadScripts"
import Footer from "./Footer"
import Header from "./Header"

function Portfolio() {

    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
            await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>
            <div id="swup">

                <Header />
                {/* <!-- content --> */}
                <div className="mil-content">
                    <div id="swupMain" className="mil-main-transition">

                        {/* <!-- banner --> */}
                        <div className="mil-inner-banner">
                            <div className="mil-banner-content mil-up">
                                <div className="mil-animation-frame">
                                    <div className="mil-animation mil-position-4 mil-dark mil-scale" data-value-1="6" data-value-2="1.4"></div>
                                </div>
                                <div className="container">
                                    <ul className="mil-breadcrumbs mil-mb-60">
                                        <li><a href="/">Homepage</a></li>
                                        <li><a href="/portfolio">Portfolio</a></li>
                                    </ul>
                                    <h1 className="mil-mb-60">Designing a <br /> Better <span className="mil-thin">World Today</span></h1>
                                    <a href="#portfolio" className="mil-link mil-dark mil-arrow-place mil-down-arrow">
                                        <span>Our works</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* <!-- banner end --> */}

                        {/* <!-- portfolio --> */}
                        <section id="portfolio">
                            <div className="container mil-portfolio mil-p-120-60">

                                <div className="mil-lines-place"></div>
                                <div className="mil-lines-place mil-lines-long"></div>

                                <div className="row justify-content-between align-items-center">
                                    <div className="col-lg-6">

                                      <Link to="/milanoodetails" className="mil-portfolio-item mil-more mil-parallax mil-mb-60" data-value-1="60" data-value-2="-60">
                                        <div className="mil-cover-frame mil-vert mil-up">
                                            <div className="mil-cover">
                                                <img src="/assets/img/works/2.jpg" alt="cover" />
                                            </div>
                                        </div>
                                            <div className="mil-descr">
                                              <h4 className="mil-up">MIlanoo Ice Cream</h4>
                                              <p className="mil-up">
                                              Black&White partnered with Milanoo Ice Cream from the ground up,
                                              crafting the brand's name, identity, packaging, story, and philosophy.
                                              Designed and more than just a dessert label, Milanoo was positioned as a playful, premium indulgence.
                                              </p>
                                            </div>
                                        </Link>

                                </div>
                                    <div className="col-lg-6">

                                        
                                        <Link to="/project" className="mil-portfolio-item mil-more mil-parallax mil-mb-60" data-value-1="60" data-value-2="-60">
                                            <div className="mil-cover-frame mil-hori mil-up">
                                                <div className="mil-cover">
                                                    <img src="/assets/img/works/2.jpg" alt="cover" />
                                                </div>
                                            </div>
                                            <div className="mil-descr">
                                                <h4 className="mil-up">Milanoo Ice Cream</h4>
                                                <p className="mil-up">
                                                   Black&White partnered with Milanoo Ice Cream from the ground up,
                                                   crafting the brand's name, identity, packaging, story, and philosophy.
                                                   Designed and more than just a dessert label, Milanoo was positioned as a playful, premium indulgence.
                                                </p>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-6">

                                        <Link to="/project" className="mil-portfolio-item mil-more mil-parallax mil-mb-60" data-value-1="60" data-value-2="-60">
                                            <div className="mil-cover-frame mil-hori mil-up">
                                                <div className="mil-cover">
                                                    <img src="/assets/img/works/3.jpg" alt="cover" />
                                                </div>
                                            </div>
                                            <div className="mil-descr">
                                                <h4 className="mil-up">Milanoo Ice Cream</h4>
                                                <p className="mil-up">
                                                   Black&White partnered with Milanoo Ice Cream from the ground up,
                                                   crafting the brand's name, identity, packaging, story, and philosophy.
                                                   Designed and more than just a dessert label, Milanoo was positioned as a playful, premium indulgence.
                                                </p>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-5">

                                        <Link to="/project" className="mil-portfolio-item mil-more mil-mb-60">
                                            <div className="mil-cover-frame mil-vert mil-up">
                                                <div className="mil-cover">
                                                    <img src="/assets/img/works/4.jpg" alt="cover" />
                                                </div>
                                            </div>
                                            <div className="mil-descr">
                                                <h4 className="mil-up">Milanoo Ice Cream</h4>
                                                <p className="mil-up">
                                                   Black&White partnered with Milanoo Ice Cream from the ground up,
                                                   crafting the brand's name, identity, packaging, story, and philosophy.
                                                   Designed and more than just a dessert label, Milanoo was positioned as a playful, premium indulgence.
                                                </p>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-5">

                                        <Link to="/project" className="mil-portfolio-item mil-more mil-mb-60">
                                            <div className="mil-cover-frame mil-vert mil-up">
                                                <div className="mil-cover">
                                                    <img src="/assets/img/works/5.jpg" alt="cover" />
                                                </div>
                                            </div>
                                            <div className="mil-descr">
                                                <h4 className="mil-up">Milanoo Ice Cream</h4>
                                                <p className="mil-up">
                                                   Black&White partnered with Milanoo Ice Cream from the ground up,
                                                   crafting the brand's name, identity, packaging, story, and philosophy.
                                                   Designed and more than just a dessert label, Milanoo was positioned as a playful, premium indulgence.
                                                </p>
                                            </div>
                                        </Link>

                                    </div>
                                    <div className="col-lg-6">

                                        <Link to="/project" className="mil-portfolio-item mil-more mil-parallax mil-mb-60" data-value-1="60" data-value-2="-60">
                                            <div className="mil-cover-frame mil-hori mil-up">
                                                <div className="mil-cover">
                                                    <img src="/assets/img/works/6.jpg" alt="cover" />
                                                </div>
                                            </div>
                                            <div className="mil-descr">
                                                <h4 className="mil-up">Milanoo Ice Cream</h4>
                                                <p className="mil-up">
                                                   Black&White partnered with Milanoo Ice Cream from the ground up,
                                                   crafting the brand's name, identity, packaging, story, and philosophy.
                                                   Designed and more than just a dessert label, Milanoo was positioned as a playful, premium indulgence.
                                                </p>
                                            </div>
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- portfolio end --> */}

                        {/* <!-- call to action --> */}
                        <section className="mil-soft-bg">
                            <div className="container mil-p-120-120">
                                <div className="row">
                                    <div className="col-lg-10">

                                        <span className="mil-suptitle mil-suptitle-right mil-suptitle-dark mil-up">Looking to make your mark? We'll help you turn <br /> your project into a success story.</span>

                                    </div>
                                </div>
                                <div className="mil-center">
                                    <h2 className="mil-up mil-mb-60">Ready to bring your <span className="mil-thin">ideas to</span> life? <br /> We're <span className="mil-thin">here to help</span></h2>
                                    <div className="mil-up"><a href="/contact" className="mil-button mil-arrow-place"><span>Contact us</span></a></div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
                {/* <!-- content --> */}


                <Footer />

            </div>

        </>
    )
}

export default Portfolio